import { FilterTypesEnum } from '../FilterTypesEnum';
import { FilterModel } from './filter.model';

export class NumberSmallerEqualFilterModel extends FilterModel {
  override symbol: FilterTypesEnum = FilterTypesEnum.num_smallerEqual;

  isValid() {
    return !!this.value;
  }
}
